import { Breadcrumbs } from '@hhgtech/hhg-components/mantine'
import { Container, ContainerProps } from '@mantine/core'

import { getHelloSitesUrl } from 'api/utils/paths'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { hasProtocol } from 'utils/hasProtocol'

export type HealthToolBreadcrumbProps = {
  pageItem: Array<
    Record<string, any> & Required<{ label: string; value: string }>
  >
} & ContainerProps

export const HealthToolBreadcrumb = ({
  pageItem,
  ...rest
}: HealthToolBreadcrumbProps) => {
  const isMobile = useIsMobile()
  const { locale } = useRouterExtend()
  return (
    <Container size="lg" my={16} {...rest}>
      <Breadcrumbs>
        {(pageItem || [])
          .map((c) => ({
            dataEventCategory: 'Breadcrumb',
            dataEventAction: 'Click',
            dataEventLabel: hasProtocol(c.value)
              ? c.value
              : `${getHelloSitesUrl(locale)}${c.value}`,
            label: c.label || '',
            value: hasProtocol(c.value)
              ? c.value
              : `${getHelloSitesUrl(locale)}${c.value}`,
          }))
          .map((item) => (
            <Breadcrumbs.Item
              key={item.value}
              href={item.value}
              {...item}
              size={isMobile ? 'p3' : 'p4'}
            >
              {item.label}
            </Breadcrumbs.Item>
          ))}
      </Breadcrumbs>
    </Container>
  )
}
